<template>
  <v-card flat outlined>
    <v-card-actions>
      <strong class="subtitle-1"><i>Customer Fixed Pricing</i></strong>
      <v-spacer></v-spacer>
      <v-alert v-if="edit_priority" type="info" class="ma-0 mr-2 pa-2" dense>The fields are disabled, click and drag rows up or down to change priority</v-alert>
      <v-spacer v-if="edit_priority"></v-spacer>
      <v-btn @click="edit_priority = false" v-if="edit_priority">Done Editing Priority Order</v-btn>
      <v-btn @click="edit_priority = true" v-else>Edit Priority</v-btn>
    </v-card-actions>
    <v-divider></v-divider>
    <v-card-text>
    <v-simple-table>
      <VueDraggable :disabled="!edit_priority" v-model="packages" draggable=".draggable" tag="tbody" @change="updatePriority">
        <tr v-for="(fixed, index) in fixedPrices" :class="`${fixed.$softDelete ? 'error lighten-2' : ''} draggable`">
          <td>{{index+1}}</td>
          <td>
            <v-text-field v-model="fixed.name" label="Display Name" :disabled="edit_priority"></v-text-field>
          </td>
          <td>
            <v-autocomplete v-model="fixed.is_customer" label="Customer(s)" :items="customers" item-text="primary_name.name" item-value="id" multiple :disabled="edit_priority"></v-autocomplete>
          </td>
          <td>
            <v-select v-model="fixed.allowed_categories" label="Allowed Categories" :items="categories" item-text="name" item-value="uuid" multiple :disabled="edit_priority"></v-select>
          </td>
          <td>
            <v-autocomplete v-model="fixed.has_flags" label="Has Flags" :items="flagTypes" item-text="name" item-value="uuid" multiple :disabled="edit_priority"></v-autocomplete>
          </td>
          <td>
            <v-select v-model="fixed.only_has_tests" label="Only Has Tests" :items="testTypes" item-text="name" item-value="uuid" multiple :disabled="edit_priority"></v-select>
          </td>
          <td>
            <v-text-field v-model="fixed.amount" label="Fixed Amount" :disabled="edit_priority"></v-text-field>
          </td>
          <td>
            <v-select v-model="fixed.optional_test_additions" label="Optional Test(s) Additions" :items="testTypes" item-text="name" item-value="uuid" multiple :disabled="edit_priority"></v-select>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{on}">
                <v-text-field v-on="on" v-model="fixed.optional_amount_addition" label="Optional Test(s) Amount" :disabled="edit_priority"></v-text-field>
              </template>
              <span>Optional Test(s) Amount - Adds on top of the fixed price</span>
            </v-tooltip>
          </td>
          <td>
            <v-checkbox v-model="fixed.allow_percent_discount" label="Allow Percentage Discount" :disabled="edit_priority"></v-checkbox>
          </td>
          <td class="text-center">
            <v-btn v-if="!fixed.$softDelete" color="error" outlined @click="remove(fixed)" small shaped :disabled="edit_priority" ><v-icon>remove</v-icon></v-btn>
            <v-tooltip v-else bottom>
              <template v-slot:activator="{on}">
                <v-btn v-on="on" outlined @click="fixed.$softDelete = false" small shaped :disabled="edit_priority" ><v-icon>undo</v-icon></v-btn>
              </template>
              <span>Undo deletion</span>
            </v-tooltip>
          </td>
        </tr>
      </VueDraggable>
    </v-simple-table>
      <v-row justify="center">
        <v-btn class="success" @click="add" dark><v-icon>add</v-icon> Create Fixed Price</v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
    name: "BillingFixedPricing",
    components: {
      VueDraggable: () => import('vuedraggable')
    },
    data: () => ({
      loading: false,
      loadingError: false,
      edit_priority: false,
      fixedPrices: []
    }),
    props: ['customers'],
    computed: {
      testTypes(){
        return this.$store.$db().model('sampleTestTypes').all()
      },
      categories(){
        return this.$store.$db().model('sampleCertTypeCategories').all()
      },
      flagTypes(){
        return this.$store.$db().model('sampleFlagTypes').all()
      },
      originalFixedPricing:{
        get(){
          return this.$store.$db().model('billingFixedPrices').all()
        },
        set(v){
          this.$store.$db().model('billingFixedPrices').insertOrUpdate({data: v});
        }
      }
    },
  watch: {
    fixedPrices: {
      deep: true,
      handler(v) {
        this.originalFixedPricing = v
      }
    }
  },
  mounted(){
      console.log(this.customers, 'customers')
    this.load()
  },
  methods: {
    async load(){
      this.loading = true;
      this.loadingError = false;
      this.fixedPrices = [];
      try{
        await this.$store.$db().model('billingFixedPrices').load();
        this.reset();
      }catch(e){
        this.loadingError = true;
        console.log(e);
      }finally{
        this.loading = false;
      }
    },
    add(){
      this.$store.$db().model('billingFixedPrices').add();
      this.reset();
    },
    remove(item){
      if(item.$isNew){
        item.$delete();
        this.reset();
      }else{
        item.$softDelete = true;
      }
    },
    async updatePriority(){
      for(let i = 0; i < this.fixedPrices.length; i+=1){
        this.fixedPrices[i].priority = i;
        // this.$set(this.packages, i, {...this.package[i], priority: i})
      }
    },
    reset(){
      this.fixedPrices = this.originalFixedPricing;
    }
  }
}
</script>

<style scoped>

</style>
